<template>
  <div class="container">
      <div class="photo">
        <a class="overlay" :href="url" target="_blank">
			<img class="social-icon" src="@/assets/icons/linkedin.svg"/>
		</a>
		<a href="https://google.com">
        	<img :src="img">
		</a>
      </div>
      <h2>{{ name }}</h2>
      <h3>{{ title }}</h3>
  </div>
</template>

<script>

export default {
  name: 'TeamMember',
  components: {
  },
  props: [
      'img',
      'name',
	  'title',
	  'url',
  ],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

@mixin breakpoint1 { @media only screen and (min-width: 0px) { @content; } }
@mixin breakpoint2 { @media only screen and (min-width: 750px) { @content; } }
@mixin breakpoint3 { @media only screen and (min-width: 1024px) { @content; } }

$scaleTransitionCurve: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
$imageDimension: 12vw;
$imageDimensionMobile: 50vw;

.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

h2, h3 {
    text-transform: uppercase;
    text-align: center;
    
}

h2 {
    font-family: 'Mont-Heavy';
    font-size: 1em;
    letter-spacing: 4pt;
    margin-top: 48px;
    margin-bottom: 0.5em;
    // margin-bottom: 0;
}

h3 {
    font-family: 'Avenir';
    font-weight: 300;
    letter-spacing: 0.3em;
    opacity: 0.8;
    margin: 0;
}


.photo, .overlay, img {

    @include breakpoint1 {
        width: $imageDimensionMobile;
        height: $imageDimensionMobile;
        transition: $scaleTransitionCurve;
        border-radius: 100%;
    }

    @include breakpoint2 {
        width: $imageDimension;
        height: $imageDimension;
        transition: $scaleTransitionCurve;
        border-radius: 100%;
    }

}

.overlay {
    background-color: #FF3B54;
    opacity: 0;
    z-index: 10;
    position: absolute;

}

.photo:hover {
	transform: scale(1.1);
}

.overlay:hover {
	opacity: 0.7;
}

.social-icon {
	width: 15%;
    opacity: 1.0;
}

</style>



// WEBPACK FOOTER //
// src/components/Team/TeamMember.vue